import { combineReducers } from '@reduxjs/toolkit'

import purchases from './purchasesSlice'
import storeOrders from './storeOrdersSlice'
import orders from './ordersSlice'
import returns from './returnsSlice'

const reducer = combineReducers({
    purchases,
    storeOrders,
    orders,
    returns,
})

export default reducer
